import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Event as NavigationEvent } from "@angular/router";
import { filter } from "rxjs/operators";
import { NavigationStart } from "@angular/router";


@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  localesList = [
    { code: 'en', label: 'EN' },
    { code: 'fr', label: 'FR' },
    { code: 'sr', label: 'SR' },
  ]
  redHome:boolean;
  redWorks: boolean;
  redAbout: boolean;
  redContact: boolean;
  isToggled: boolean;
  constructor(
    private _router: Router) {
    _router.events
      .pipe(
        filter(
          (event: NavigationEvent) => {
            return (event instanceof NavigationStart);
          }
        )
      )
      .subscribe(
        (event: NavigationStart) => {

          // console.log("route:", event.url);
          // console.log("trigger:", event.navigationTrigger);

          if (event.restoredState) {
            this.redHome=false;
            this.redWorks=false;
            this.redAbout=false;
            this.redContact=false;
            if (event.url == "/home") { this.redHome = true; }
            if (event.url == "/works") { this.redWorks = true; }
            if (event.url == "/about") { this.redAbout = true; }
            if (event.url == "/contact") { this.redContact = true; }
          }
        }
      )
      ;
  }
  ngOnInit(): void {
   this.redHome = false;
    this.redAbout = false;
    this.redWorks = false;
    this.redContact = false;
    this.isToggled = false;
  }
  toHome() {
    this._router.navigate(['home']
    );

    this.redHome = true;
    this.redAbout = false;
    this.redWorks = false;
    this.redContact = false;

  }
  toAbout() {
    this._router.navigate(['about']);
    this.redAbout = true;
   this.redHome = false;
   this.redWorks = false;
   this.redContact = false;
  }
  toWorks() {
    this._router.navigate(['works']);
    this.redWorks = true;
    this.redHome = false ;
    this.redAbout = false ;
     this.redContact = false;
  }
  toContact() {
    this._router.navigate(['contact']);
    this.redContact = true;
    this.redHome = false;
     this.redWorks = false;
     this.redAbout = false;
  }
  toggle() {
    this.isToggled = !this.isToggled;
  }
  
}
